import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

export const IntranetContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #f5f5f5;
  font-family: 'Raleway', sans-serif;
`;

export const Sidebar = styled.aside`
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 256px;
  background-color: #1e293b;
  color: white;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  overflow-y: auto;
  overflow-x: hidden;
  transition: transform 0.3s ease-in-out;
  transform: translateX(${(props) => (props.$isOpen ? '0' : '-100%')});

  @media (min-width: ${parseInt(screenSizes.tablet) + 1}px) {
    transform: translateX(0);
    position: fixed;
  }

  @media (max-width: ${screenSizes.tablet}) {
    width: 280px;
    max-width: 85vw;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.3);
  }

  .sidebar-header {
    padding: 1.5rem;
    border-bottom: 1px solid #334155;
    flex-shrink: 0;

    @media (max-width: ${screenSizes.mobile}) {
      padding: 1rem;
    }

    h1 {
      margin: 0;
      font-size: 1.5rem;
      font-weight: 700;
      color: #60a5fa;
      letter-spacing: -0.025em;

      @media (max-width: ${screenSizes.mobile}) {
        font-size: 1.25rem;
      }
    }

    p {
      margin: 0.25rem 0 0 0;
      font-size: 0.75rem;
      color: #94a3b8;
      text-transform: uppercase;
      letter-spacing: 0.1em;

      @media (max-width: ${screenSizes.mobile}) {
        font-size: 0.7rem;
      }
    }
  }

  .sidebar-nav {
    flex: 1;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    @media (max-width: ${screenSizes.mobile}) {
      padding: 0.75rem;
      gap: 0.375rem;
    }

    .nav-button {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 0.75rem;
      padding: 0.75rem 1rem;
      border-radius: 0.5rem;
      transition: all 0.2s ease;
      background: none;
      border: none;
      color: #cbd5e1;
      cursor: pointer;
      font-size: 0.95rem;
      text-align: left;
      min-height: 44px; /* Better touch target for mobile */

      @media (max-width: ${screenSizes.mobile}) {
        padding: 0.875rem 1rem;
        font-size: 0.9rem;
      }

      &:hover {
        background-color: #334155;
        color: white;
      }

      &:active {
        transform: scale(0.98);
      }

      &.active,
      &:hover.active {
        background-color: #2563eb;
        color: white;
        font-weight: 600;
      }

      i {
        width: 1.25rem;
        text-align: center;
      }
    }
  }

  .sidebar-footer {
    padding: 1rem;
    border-top: 1px solid #334155;
    flex-shrink: 0;

    @media (max-width: ${screenSizes.mobile}) {
      padding: 0.75rem;
    }

    .user-info {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      padding: 0.75rem;
      color: #cbd5e1;

      @media (max-width: ${screenSizes.mobile}) {
        padding: 0.5rem;
        gap: 0.5rem;
      }

      .user-avatar {
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        background-color: #2563eb;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-weight: 700;
        font-size: 0.875rem;
        flex-shrink: 0;

        @media (max-width: ${screenSizes.mobile}) {
          width: 1.75rem;
          height: 1.75rem;
          font-size: 0.75rem;
        }
      }

      .user-details {
        flex: 1;
        overflow: hidden;
        min-width: 0;

        .user-name {
          font-size: 0.875rem;
          font-weight: 500;
          color: white;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          @media (max-width: ${screenSizes.mobile}) {
            font-size: 0.8rem;
          }
        }

        .user-role {
          font-size: 0.75rem;
          color: #94a3b8;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          @media (max-width: ${screenSizes.mobile}) {
            font-size: 0.7rem;
          }
        }
      }
    }

    .logout-button {
      width: 100%;
      margin-top: 1rem;
      display: flex;
      align-items: center;
      gap: 0.75rem;
      padding: 0.5rem 1rem;
      border-radius: 0.5rem;
      transition: all 0.2s ease;
      background: none;
      border: none;
      color: #f87171;
      cursor: pointer;
      font-size: 0.875rem;
      text-align: left;
      min-height: 44px; /* Better touch target for mobile */

      @media (max-width: ${screenSizes.mobile}) {
        margin-top: 0.75rem;
        padding: 0.625rem 1rem;
        font-size: 0.8rem;
      }

      &:hover {
        background-color: rgba(239, 68, 68, 0.1);
      }

      &:active {
        transform: scale(0.98);
      }

      i {
        width: 1.25rem;
        text-align: center;
      }
    }
  }
`;

export const MobileMenuButton = styled.button`
  display: none;
  position: fixed;
  bottom: 1rem;
  left: 1rem;
  z-index: 1001;
  background-color: #1e293b;
  color: white;
  border: none;
  border-radius: 0.5rem;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
  min-height: 44px; /* Better touch target */

  @media (min-width: ${parseInt(screenSizes.tablet) + 1}px) {
    display: none;
  }

  @media (max-width: ${screenSizes.tablet}) {
    display: flex;
  }

  &:hover {
    background-color: #334155;
  }

  &:active {
    transform: scale(0.95);
  }

  i {
    font-size: 1.25rem;
    color: inherit;
    display: inline-block;
    line-height: 1;
  }
`;

export const Overlay = styled.div`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  visibility: ${(props) => (props.$isOpen ? 'visible' : 'hidden')};
  transition: opacity 0.3s ease, visibility 0.3s ease;

  @media (min-width: ${parseInt(screenSizes.tablet) + 1}px) {
    display: none;
  }

  @media (max-width: ${screenSizes.tablet}) {
    display: block;
  }
`;

export const MainContent = styled.main`
  padding: 2rem;
  flex: 1;
  margin-left: 256px;
  transition: all 0.3s ease;
  width: 100%;
  min-width: 0; /* Prevent overflow */

  @media (max-width: ${screenSizes.tablet}) {
    margin-left: 0;
    padding: 1.5rem;
    padding-bottom: 5rem; /* Space for mobile menu button at bottom */
  }

  @media (max-width: ${screenSizes.mobile}) {
    padding: 1rem;
    padding-bottom: 4.5rem;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
`;

export const MainHeader = styled.div`
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: ${screenSizes.mobile}) {
    margin-bottom: 1.5rem;
    gap: 0.75rem;
  }

  .header-title {
    flex: 1;
    min-width: 0;

    h2 {
      margin: 0 0 0.5rem 0;
      font-size: 2rem;
      font-weight: 700;
      color: #1e293b;
      word-wrap: break-word;

      @media (max-width: ${screenSizes.tablet}) {
        font-size: 1.75rem;
      }

      @media (max-width: ${screenSizes.mobile}) {
        font-size: 1.5rem;
        margin-bottom: 0.25rem;
      }
    }

    .date-display {
      display: block;
      font-size: 0.875rem;
      color: #64748b;
      font-weight: 500;
      margin-bottom: 0.5rem;
      word-wrap: break-word;

      @media (max-width: ${screenSizes.tablet}) {
        font-size: 0.8rem;
      }

      @media (max-width: ${screenSizes.mobile}) {
        font-size: 0.75rem;
        margin-bottom: 0.375rem;
      }

      @media (max-width: 360px) {
        font-size: 0.7rem;
      }
    }

    p {
      margin: 0;
      color: #64748b;
      font-size: 0.95rem;

      @media (max-width: ${screenSizes.mobile}) {
        font-size: 0.85rem;
      }
    }
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-shrink: 0;

    @media (max-width: ${screenSizes.mobile}) {
      width: 100%;
      justify-content: space-between;
      gap: 0.5rem;
    }

    .notification-button {
      position: relative;
      padding: 0.5rem;
      background: none;
      border: none;
      color: #64748b;
      cursor: pointer;
      font-size: 1.25rem;
      transition: color 0.2s ease;
      min-width: 44px;
      min-height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        color: #1e293b;
      }

      .notification-badge {
        position: absolute;
        top: 0.25rem;
        right: 0.25rem;
        width: 0.5rem;
        height: 0.5rem;
        background-color: #ef4444;
        border-radius: 50%;
        border: 2px solid white;
      }
    }

    .divider {
      height: 2.5rem;
      width: 1px;
      background-color: #e2e8f0;

      @media (max-width: ${screenSizes.mobile}) {
        display: none;
      }
    }

    .date-display {
      font-size: 0.875rem;
      color: #64748b;
      font-weight: 500;
      white-space: nowrap;

      @media (max-width: ${screenSizes.mobile}) {
        font-size: 0.8rem;
      }

      @media (max-width: 360px) {
        font-size: 0.75rem;
      }
    }
  }
`;
